<template>
  <main>
    <!-- <b-row>
      <b-col class="request-header" lg="6" md="12" sm="12" xl="6"
        >
      </b-col>
    </b-row> -->
    <b-row>
      <b-col class="mb-3 order-lg-1" lg="6" md="12" sm="12" xl="6">
        <p class="request-header">Application Role Recommendations</p>
        <p class="recommendation-explain">
          Select your site role to see suggested application access/roles below. You can change the
          applications/roles as needed. If you need to deselect an application from the recommended
          list. please select "None" as the role.
        </p>
        <p class="select-label mt-2 mb-1 pl-3">SELECT YOUR SITE ROLE</p>
        <b-form-select
          v-model="selected"
          :disabled="presets.length === 0"
          :options="presets"
          class="mb-2"
          style="border: 2px solid #0095ff; border-radius: 24px"
          @change="onChange"
        >
          <template #first>
            <b-form-select-option :value="null" disabled>- Role Presets</b-form-select-option>
          </template>
        </b-form-select>
      </b-col>
      <b-col class="order-lg-2" lg="6" md="12" sm="12" xl="6">
        <p class="request-header">Good to Know</p>
        <ul class="recommendation-explain">
          <li>
            Application Access: Use this to manage your access, as well as access for any site staff
            to the systems used to conduct Pfizer trials.
            <i
              >Note: when submitting access requests on behalf of others, the site acknowledges and
              agrees that any individual from your institution for whom personal data is provided in
              this form have been notified of the disclosure of their personal data to Pfizer.</i
            >
          </li>
          <li>
            Training: Complete any required application training.
          </li>
          <li>
            Note: Some applications may not be available yet for processing and will take longer to
            provision.
          </li>
          <li>
            Modifying Requests: To modify an existing request, simply update the role you need and
            click Submit Request.
          </li>
          <li>
            Deactivating Accounts: To deactivate an account, click on the trash can and select a
            reason. If you do not see the trash can, select Remove Access in the system role
            dropdown.
          </li>
        </ul>
      </b-col>
    </b-row>

    <b-modal
      id="warningModal"
      body-class="pt-0 text-secondary"
      centered
      footerClass="p-2 border-top-0"
      headerClass="p-2 mt-2 border-bottom-0"
      @cancel="cancelWarningModal()"
      @ok="warningModalOk()"
      ><p>
        Are you sure you want to change the selected role? By selecting new role you will lose all
        your progress.
      </p>
      <template #modal-header="{ hide }">
        <p class="modal-header-text font-weight-bold pb-0 mb-0 pl-1">Warning!</p>
        <b-button class="float-right" variant="link-dark" @click="hide()">
          <b-icon icon="x"></b-icon>
        </b-button>
      </template>
      <template #modal-footer="{ ok, cancel }">
        <b-button pill variant="primary" @click="ok()"> Select new role</b-button>
        <b-button pill variant="link" @click="cancel()">Cancel</b-button>
      </template>
    </b-modal>
    <b-modal
      id="selectDefaultRole"
      body-class="pt-0 text-secondary"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      footerClass="p-2 border-top-0"
      headerClass="p-2 mt-2 border-bottom-0"
      @ok="closeRoleSelectedModal()"
      ><p>
        Choose a default role so we can suggest you some requests.
      </p>
      <b-form-select
        v-model="modalSelectDefaultRole"
        :options="roles"
        value-field="role"
        text-field="role"
        size="sm"
        class="mt-3"
      >
        <template #first>
          <b-form-select-option value="null" disabled
            >-- Please select an default role --</b-form-select-option
          >
        </template></b-form-select
      >
      <template #modal-header="{}">
        <p class="modal-header-text font-weight-bold pb-0 mb-0 pl-1">Select Role</p>
      </template>
      <template #modal-footer="{ ok }">
        <b-button pill variant="primary" :disabled="modalSelectDefaultRole === null" @click="ok()"
          >Select role</b-button
        >
      </template>
    </b-modal>
  </main>
</template>
<script>
  import { mapGetters } from 'vuex';

  export default {
    name: 'application-role-recommendations',
    props: {
      checkedRequests: Array,
      studyId: String,
      roles: { type: Array, default: () => [] },
      requestsSize: Number,
    },
    data() {
      return {
        selected: null,
        oldRole: null,
        modalSelectDefaultRole: null,
        defaultRole: '',
      };
    },
    computed: {
      ...mapGetters(['presets']),
    },
    watch: {
      selected(newValue, oldValue) {
        this.oldRole = oldValue;
      },
      presets(newValue) {
        if (newValue.length > 0) {
          this.checkForSetDefaultRole();
        }
      },
    },
    created() {
      if (this.presets.length === 0) {
        let payload = { studyId: this.studyId };
        if (this.$route.query['token']) {
          payload.token = this.$route.query['token'];
        }
        this.$store.dispatch('getAccessRequestPresets', payload);
      } else {
        this.checkForSetDefaultRole();
      }
    },
    methods: {
      checkForSetDefaultRole() {
        if (this.requestsSize !== 0 || this.roles.length === 0) {
          return;
        }
        if (this.roles.length === 1) {
          this.defaultRole = this.roles[0]['role'];
          this.setDefaultRole();
        }
        if (this.roles.length > 1) {
          this.$nextTick(() => {
            this.$bvModal.show('selectDefaultRole');
          });
        }
      },
      closeRoleSelectedModal() {
        this.defaultRole = this.modalSelectDefaultRole;
        this.$bvModal.hide('selectDefaultRole');
        this.setDefaultRole();
      },
      setDefaultRole() {
        let foundIndex = this.presets.findIndex(
          el => el['text'].toUpperCase() === this.defaultRole.toUpperCase(),
        );
        this.selected = this.presets[foundIndex]['value'];
        this.onChange();
      },
      warningModalOk() {
        this.$emit('separateApplications', this.selected);
      },
      cancelWarningModal() {
        this.selected = this.oldRole;
        this.$bvModal.hide('warningModal');
      },
      onChange() {
        if (this.checkedRequests.length > 0 && this.selected !== this.oldRole) {
          this.$bvModal.show('warningModal');
        } else {
          this.$emit('separateApplications', this.selected);
        }
      },
    },
  };
</script>
<style scoped>
  .request-header {
    font-weight: 500;
    font-size: 18px;
    line-height: 28px;
    letter-spacing: 0.25px;
    color: #1c1b1e;
  }

  .recommendation-explain {
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    letter-spacing: 0.5px;
    color: #006a68;
  }

  .select-label {
    font-weight: 400;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.25px;
    text-transform: uppercase;
    color: #404040;
  }
</style>
